/* DogSmile — interactions */
(function () {
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = w.DS_I18N || { acc: 'accessoire', accs: 'accessoires', offert: 'offert', total: 'Total', lead_ok: 'C’est noté. Vous recevrez nos prochains conseils par e-mail.', dog: 'votre chien' };
  d.documentElement.classList.add('ds-js');

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  ready(function () {
    var targets = qsa('[data-reveal], [data-lines]');
    var showAll = function () { targets.forEach(function (t) { t.classList.add('is-in'); }); };
    if ('IntersectionObserver' in w && !reduce) {
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        fired = true;
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      var vh = w.innerHeight;
      targets.forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) t.classList.add('is-in'); else io.observe(t);
      });
      setTimeout(function () { if (!fired) showAll(); }, 2500);
    } else { showAll(); }

    var header = d.querySelector('.ds-header');
    if (header) {
      var first = d.querySelector('#MainContent > .shopify-section:first-child [data-header-dark]');
      if (first) header.setAttribute('data-theme', 'dark');
      var lastY = w.scrollY, ticking = false;
      var onScroll = function () {
        var y = w.scrollY;
        header.classList.toggle('is-solid', y > 40);
        header.classList.toggle('is-hidden', y > 320 && y > lastY && !d.body.classList.contains('ds-menu-open'));
        lastY = y; ticking = false;
      };
      w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });
      onScroll();
    }

    var menu = d.querySelector('.ds-menu');
    qsa('[data-menu-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        d.body.classList.toggle('ds-menu-open', open);
        d.body.style.overflow = open ? 'hidden' : '';
        qsa('[data-menu-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      });
    });
    qsa('.ds-menu a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); d.body.style.overflow = ''; d.body.classList.remove('ds-menu-open'); }); });

    if (!reduce) {
      qsa('[data-tilt]').forEach(function (wrap) {
        var card = wrap.querySelector('[data-tilt-card]') || wrap;
        wrap.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = wrap.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateZ(0)';
        });
        wrap.addEventListener('pointerleave', function () { card.style.transform = ''; });
      });
      var px = qsa('[data-parallax]');
      if (px.length) {
        var pt = false;
        var runPx = function () {
          var vh2 = w.innerHeight;
          px.forEach(function (el) {
            var r = el.parentElement.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh2 + 200) return;
            var s = parseFloat(el.getAttribute('data-parallax')) || 0.15;
            var c = r.top + r.height / 2 - vh2 / 2;
            el.style.transform = 'translate3d(0,' + (-c * s).toFixed(1) + 'px,0)';
          });
          pt = false;
        };
        w.addEventListener('scroll', function () { if (!pt) { pt = true; w.requestAnimationFrame(runPx); } }, { passive: true });
        runPx();
      }
      qsa('[data-magnetic]').forEach(function (b) {
        b.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = b.getBoundingClientRect();
          b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.18) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.28) + 'px)';
        });
        b.addEventListener('pointerleave', function () { b.style.transform = ''; });
      });
    }

    var counters = qsa('[data-count]');
    if (counters.length && 'IntersectionObserver' in w && !reduce) {
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          co.unobserve(e.target);
          var el = e.target, to = parseFloat(el.getAttribute('data-count')), dec = parseInt(el.getAttribute('data-dec') || '0', 10);
          var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
          var t0 = null, dur = 1600;
          var step = function (t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / dur, 1), v = to * (1 - Math.pow(1 - p, 4));
            el.textContent = pre + v.toFixed(dec).replace('.', ',') + suf;
            if (p < 1) w.requestAnimationFrame(step);
          };
          w.requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });
      counters.forEach(function (c) { co.observe(c); });
    }

    qsa('[data-story]').forEach(function (story) {
      var imgs = qsa('.ds-story__media img', story), steps = qsa('.ds-step', story);
      if (!('IntersectionObserver' in w)) { steps.forEach(function (s) { s.classList.add('is-active'); }); return; }
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = steps.indexOf(e.target);
          steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
          imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { so.observe(s); });
      if (steps[0]) steps[0].classList.add('is-active');
    });

    qsa('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('.ds-gallery__main'), thumbs = qsa('.ds-gallery__thumbs button', g);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { main.scrollTo({ left: main.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' }); });
      });
      main.addEventListener('scroll', function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, { passive: true });
    });

    qsa('[data-ds-form]').forEach(function (form) {
      var labels = qsa('[data-price-label]');
      var cur = function () { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]'); };
      var addons = function () { return qsa('input[data-addon]:checked', form); };
      var sync = function () {
        var r = cur(); if (!r) return;
        var base = parseInt(r.getAttribute('data-cents'), 10) || 0;
        var isR = r.hasAttribute('data-routine');
        var adds = addons().map(function (i) { return parseInt(i.getAttribute('data-cents'), 10) || 0; });
        var sum = adds.reduce(function (a, b) { return a + b; }, 0);
        var free = (isR && adds.length) ? Math.min.apply(null, adds) : 0;
        var total = base + sum - free;
        labels.forEach(function (l) { l.textContent = fmt(total); });
        qsa('[data-free-badge],[data-free-note]', form).forEach(function (el) { el.hidden = !isR; });
        var row = form.querySelector('[data-total-row]');
        if (row) {
          row.hidden = !adds.length;
          var det = row.querySelector('[data-total-detail]');
          if (det) det.textContent = adds.length + ' ' + (adds.length > 1 ? T.accs : T.acc) + (free ? ' · 1 ' + T.offert + ' (−' + fmt(free) + ')' : '');
          var t = row.querySelector('[data-total]');
          if (t) t.textContent = T.total + ' ' + fmt(total);
        }
      };
      form.addEventListener('change', sync); sync();
      form.addEventListener('submit', function (e) {
        if (!w.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var items = [{ id: parseInt(cur().value, 10), quantity: 1 }];
        addons().forEach(function (i) { items.push({ id: parseInt(i.value, 10), quantity: 1 }); });
        if (w.DS_BONUS && form.querySelector('input[type="radio"][name="id"]')) items.push({ id: parseInt(w.DS_BONUS, 10), quantity: 1 });
        fetch((w.Shopify && w.Shopify.routes ? w.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (res) { if (!res.ok) throw new Error('add'); w.location.href = form.getAttribute('data-next') || '/checkout'; })
          .catch(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } form.submit(); });
      });
    });
    qsa('[data-buy-proxy]').forEach(function (b) {
      b.addEventListener('click', function () { var f = d.querySelector('[data-ds-form]'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); });
    });

    var bar = d.querySelector('.ds-sticky-buy'), anchor = d.querySelector('[data-buy-anchor]');
    if (bar && anchor && 'IntersectionObserver' in w) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(anchor);
    }

    qsa('[data-quiz]').forEach(initQuiz);
  });

  function initQuiz(root) {
    var steps = qsa('.ds-quiz__step', root), bar = root.querySelector('.ds-quiz__bar i');
    var ans = {}, idx = 0, total = steps.length - 1;
    function show(i, noScroll) {
      idx = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (bar) bar.style.width = Math.round((Math.min(i, total) / total) * 100) + '%';
      var f = steps[i].querySelector('input, button'); if (f && i > 0) f.focus({ preventScroll: true });
      if (!noScroll) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    qsa('[data-q] button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.closest('[data-q]');
        qsa('button', step).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        ans[step.getAttribute('data-q')] = b.getAttribute('data-v');
        setTimeout(function () { next(); }, reduce ? 0 : 260);
      });
    });
    qsa('[data-next]', root).forEach(function (b) { b.addEventListener('click', function () { next(); }); });
    qsa('[data-prev]', root).forEach(function (b) { b.addEventListener('click', function () { if (idx > 0) show(idx - 1); }); });
    function next() {
      var nameIn = root.querySelector('[name="dog_name"]');
      if (nameIn) ans.name = (nameIn.value || '').trim();
      if (idx + 1 === total) result();
      show(Math.min(idx + 1, total));
    }
    function result() {
      var name = ans.name || T.dog;
      var p = 'classique';
      if (ans.touch === 'fuit') p = 'pasapas';
      else if (ans.age === 'chiot') p = 'decouverte';
      else if (ans.age === 'senior') p = 'senior';
      else if (ans.size === 'petit' || ans.muzzle === 'court') p = 'petite';
      var res = root.querySelector('[data-result]');
      qsa('[data-profile]', res).forEach(function (el) { el.hidden = el.getAttribute('data-profile') !== p; });
      qsa('[data-dog-name]', res).forEach(function (el) { el.textContent = name; });
      var alert = res.querySelector('[data-alert]');
      if (alert) alert.hidden = !(ans.gums === 'rouge' || ans.gums === 'depots');
      var cta = res.querySelector('[data-quiz-cta]');
      if (cta) { var v = p === 'decouverte' ? cta.getAttribute('data-starter') : cta.getAttribute('data-routine'); if (v) cta.href = cta.getAttribute('data-base') + '?variant=' + v; }
      var tags = res.querySelector('[name="contact[tags]"]');
      if (tags) tags.value = 'quiz,profil-' + p;
      var note = res.querySelector('[name="contact[note]"]');
      if (note) note.value = 'Chien : ' + name + ' | profil ' + p;
    }
    var lead = root.querySelector('[data-lead]');
    if (lead) lead.addEventListener('submit', function (e) {
      if (!w.fetch) return;
      e.preventDefault();
      fetch(lead.action, { method: 'POST', body: new FormData(lead) }).finally(function () {
        var p = d.createElement('p'); p.className = 'ds-quiz__alert'; p.textContent = T.lead_ok;
        lead.innerHTML = ''; lead.appendChild(p);
      });
    });
    show(0, true);
  }
})();
